<!-- =========================================================================================
  File Name: SigepTabInformation.vue
  Description: Sigep Information Tab content
========================================================================================== -->
<template>
  <div id="sigep-tab-info">
    <p class="mb-5">
      Por favor, preencha todas as informações abaixo sobre sua conta do <code>SIGEP WEB Master</code> para poder autenticar sua conta nos servidores dos Correios
    </p>
    <vs-alert active="true" class="mb-5">
      <span></span>
      <span>Lembre-se que você <code>só conseguirá utilizar a APP do SIGEP</code> (ver suas ordens importadas e gerar PLP e Etiquetas de envio) quando suas credenciais <code>forem autenticadas</code> junto aos Correios.</span>
    </vs-alert>
    <p class="mb-10">
      Qualquer dúvida entre em contato conosco via e-mail para <code>support@gadolapps.com</code>
    </p>
    <img src="https://erp.tiny.com.br/images/cartao-postagem-correios-sm.png?v=3" class="mb-10" />
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2">
        <div class="important-section">
          <!-- Col Header -->
          <div class="flex items-end">
            <feather-icon icon="UserIcon" class="mr-2" svgClasses="w-5 h-5" />
            <span class="leading-none font-medium">Novas Credenciais dos Correios</span>
          </div>
          <!-- Col Content -->
          <div>
            <!-- usuario correios -->
            <vs-input class="w-full mt-4" label="Id Correios" v-model="data_local.usuario_api" v-validate="'required'" name="usuario_api" />
            <a href="/credentials/sigep/help/id-correios" target="_blank" title="Clique aqui para acessar o passo a passo de como localizar o seu Id Correios">
              <span class="text-danger text-sm" v-show="errors.has('usuario_api')">Campo Obrigatório</span>
              <span class="text-description text-sm" v-show="!errors.has('usuario_api')">Identificador para acessar a nova API dos correios. Normalmente 14 números</span>
            </a>
            <!-- senha correios -->
            <vs-input class="w-full mt-4" label="Codigo API" v-model="data_local.senha_api" v-validate="'required'" name="senha_api" />
            <a href="/credentials/sigep/help/codigo-api" target="_blank" title="Clique aqui para acessar o passo a passo de como localizar o seu codigo">
              <span class="text-danger text-sm" v-show="errors.has('senha_api')">Campo Obrigatório</span>
              <span class="text-description text-sm" v-show="!errors.has('senha_api')">Codigo para acessar a nova API dos correios. Normalmente formado de caracteres alphanuméricos</span>
            </a>         
            <!-- nova caixa postal -->
            <vs-input class="w-full mt-4" label="Novo Número do Cartão de Postagem" v-model="data_local.cartao_postagem_api" v-validate="'digits:10|numeric'" data-vv-as="Novo Cartão de Postagem" name="cartao_postagem_api" />
            <span class="text-danger text-sm" v-show="errors.has('cartao_postagem_api')">{{ errors.first('cartao_postagem_api') }}</span>
            <span class="text-description text-sm" v-show="!errors.has('cartao_postagem_api')">Cartão de Postagem para acessar a API</span>     
          </div>
        </div>
        <!-- Col Header -->
        <div class="flex items-end mt-8">
          <feather-icon icon="UserIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Credenciais</span>
        </div>
        <!-- Col Content -->
        <div>
          <vs-input class="w-full mt-4" label="Usuário SIGEP Web Master" v-model="data_local.usuario" v-validate="'required'" name="usuario" />
          <span class="text-danger text-sm" v-show="errors.has('usuario')">Campo Obrigatório</span>
          <span class="text-description text-sm" v-show="!errors.has('usuario')">Usuário para acessar o SIGEP (SIGEP WEB Master). Normalmente 14 números</span>
          <vs-input class="w-full mt-4" label="Senha SIGEP Web MASTER" v-model="data_local.senha" v-validate="'required'" name="senha" />
          <span class="text-danger text-sm" v-show="errors.has('senha')">Campo Obrigatório</span>
          <span class="text-description text-sm" v-show="!errors.has('senha')">Senha para acessar o SIGEP (SIGEP WEB Master). Normalmente 6 caracteres alphanuméricos</span>
          <vs-input class="w-full mt-4" label="(1) Número do Cartão de Postagem" v-model="data_local.cartao_postagem" v-validate="'digits:10|numeric'" data-vv-as="Cartão de Postagem" name="cartao_postagem" />
          <span class="text-danger text-sm" v-show="errors.has('cartao_postagem')">{{ errors.first('cartao_postagem') }}</span>
          <span class="text-description text-sm" v-show="!errors.has('cartao_postagem')">Cartão de Postagem para acessar o SIGEP</span>          
        </div>
        <div class="flex items-end mt-8">
          <feather-icon icon="UserIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Informações do Contrato SIGEP</span>
        </div>
        <div class="mt-4">
            <label class="text-sm">(2) Diretoria Regional (DR)</label>
            <v-select :reduce="r => r.value" v-model="data_local.diretoria" :options="diretoriaOptions" v-validate="'required'" name="diretoria" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            <span class="text-danger text-sm" v-show="errors.has('diretoria')">Campo Obrigatório</span>
            <span class="text-description text-sm" v-show="!errors.has('diretoria')">Normalmente o estado que você firmou contrato com os Correios</span>
          </div>
        <div>
          <vs-input class="w-full mt-4" label="(3) Código Administrativo" v-model="data_local.codigo_administrativo" v-validate="'required'" name="codigo_administrativo" />
          <span class="text-danger text-sm" v-show="errors.has('codigo_administrativo')">Campo Obrigatório</span>
          <span class="text-description text-sm" v-show="!errors.has('codigo_administrativo')">Código Administrativo para acessar o SIGEP</span>
          <vs-input class="w-full mt-4" label="(4) Número do Contrato" v-model="data_local.contrato" v-validate="'required'" name="contrato" />
          <span class="text-danger text-sm" v-show="errors.has('contrato')">Campo Obrigatório</span>
          <span class="text-description text-sm" v-show="!errors.has('contrato')">Número do Contrato para acessar o SIGEP</span>
          <vs-input class="w-full mt-4" label="CNPJ" v-model="data_local.cnpj" v-validate="'digits:14|numeric'" name="cnpj" data-vv-as="CNPJ" />
          <span class="text-danger text-sm" v-show="errors.has('cnpj')">{{ errors.first('cnpj') }}</span>
          <span class="text-description text-sm" v-show="!errors.has('cnpj')">CNPJ para acessar o SIGEP - somente números</span>
        </div>
      </div>
      <!-- Address Col -->
      <div class="vx-col w-full md:w-1/2">
        <!-- Col Header -->
        <div class="flex items-end md:mt-0 mt-base">
          <feather-icon icon="MapPinIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Remetente</span>
        </div>
        <!-- Col Content -->
        <div>
          <vs-input class="w-full mt-4" label="(5) Nome do Cliente" v-model="data_local.remetente.first_name" v-validate="'required'" name="first_name" />
          <span class="text-danger text-sm" v-show="errors.has('first_name')">Campo Obrigatório</span>
          <div class="vx-row">
            <div class="vx-col w-3/4">
              <vs-input class="w-full mt-4" label="Endereço" v-model="data_local.remetente.address" v-validate="'required'" name="address" />
              <span class="text-danger text-sm" v-show="errors.has('address')">Campo Obrigatório</span>
            </div>
            <div class="vx-col w-1/4">
              <vs-input class="w-full mt-4" label="Número" v-model="data_local.remetente.number" v-validate="'required|max:5'" data-vv-as="Número" name="number" />
              <span class="text-danger text-sm" v-show="errors.has('number')">{{ errors.first('number') }}</span>
            </div>
          </div>
          <vs-input class="w-full mt-4" label="Complemento" v-model="data_local.remetente.complement" name="complement" />
          <span class="text-danger text-sm" v-show="errors.has('complement')">Campo Obrigatório</span>
          <div class="vx-row">
            <div class="vx-col w-3/4">
              <vs-input class="w-full mt-4" label="Bairro" v-model="data_local.remetente.region" v-validate="'required'" name="region" />
              <span class="text-danger text-sm" v-show="errors.has('region')">Campo Obrigatório</span>
            </div>
            <div class="vx-col w-1/4">
              <vs-input class="w-full mt-4" label="CEP" data-vv-as="CEP" v-model="data_local.remetente.zip_code" v-validate="'required|digits:8|numeric'" name="zip_code" />
              <span class="text-danger text-sm" v-show="errors.has('zip_code')">{{ errors.first('zip_code') }}</span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-1/2">
              <vs-input class="w-full mt-4" label="Cidade" v-model="data_local.remetente.city" v-validate="'required'" name="city" />
              <span class="text-danger text-sm" v-show="errors.has('city')">Campo Obrigatório</span>
            </div>
            <div class="vx-col w-1/2">
              <div class="mt-4">
                <label class="text-sm">Estado</label>
                <v-select :reduce="r => r.value" v-model="data_local.remetente.state" :options="valorStates" v-validate="'required'" name="state" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm" v-show="errors.has('state')">Campo Obrigatório</span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex items-end mt-16">
          <feather-icon icon="UserIcon" class="mr-2" svgClasses="w-5 h-5" />
          <span class="leading-none font-medium">Configurações de Envio</span>
        </div>
        <div>
          <!-- <vs-input class="w-full mt-4" label="País" v-model="data_local.remetente.country" v-validate="'required'" name="country" /> -->
          <!-- <span class="text-danger text-sm" v-show="errors.has('country')">Campo Obrigatório</span> -->
          <div class="mt-4">
            <label class="text-sm">Declarar NF?</label>
            <div class="mt-2">
              <vs-radio v-model="data_local.config_declarar_nf" v-bind:vs-value="true" class="mr-4">Sim</vs-radio>
              <vs-radio v-model="data_local.config_declarar_nf" v-bind:vs-value="false" class="mr-4">Não</vs-radio>
            </div>
          </div>
          <div class="mt-4">
            <label class="text-sm">Declarar Valores?</label>
            <v-select :reduce="r => r.value" v-model="data_local.config_declarar_valor" :options="valorOptions" v-validate="'required'" name="config_declarar_valor" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            <span class="text-danger text-sm" v-show="errors.has('config_declarar_valor')">Campo Obrigatório</span>
            <span class="text-description text-sm" v-show="!errors.has('config_declarar_valor')">Escolha como clarar valores para o SIGEP</span>
          </div>
          <vs-input class="w-full mt-4" label="Logo" v-model="data_local.config_logo" v-validate="" name="config_logo" />
          <span class="text-danger text-sm" v-show="errors.has('config_logo')">Campo Obrigatório</span>
          <span class="text-description text-sm" v-show="!errors.has('config_logo')">O URL da sua logo para aparecer nas etiquetas dos Correios</span>
        </div>
      </div>
    </div>
    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="save_changes" :disabled="!validateForm">Salvar Alterações</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import flatPickr from 'vue-flatpickr-component'
//import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
    // flatPickr
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {

      valorOptions: [
        { label: "Declarar valor 0", value: 0 },
        { label: "Declarar Produtos + Frete", value: 1 },
        { label: "Declarar Produtos Somente", value: 2 },
        { label: "Nao Declarar", value: 3 },
      ],

      diretoriaOptions: [
        { value: "1", label: 'AC Administraçao Central' },
        { value: "3", label: 'DR - Acre' },
        { value: "4", label: 'DR - Alagoas' },
        { value: "6", label: 'DR - Amazonas' },
        { value: "5", label: 'DR - Amapá' },
        { value: "8", label: 'DR - Bahia' },
        { value: "10", label: 'DR - Brasília' },
        { value: "12", label: 'DR - Ceará' },
        { value: "14", label: 'DR - Espirito Santo' },
        { value: "16", label: 'DR - Goiás' },
        { value: "18", label: 'DR - Maranhão' },
        { value: "20", label: 'DR - Minas Gerais' },
        { value: "22", label: 'DR - Mato Grosso do Sul' },
        { value: "24", label: 'DR - Mato Grosso' },
        { value: "28", label: 'DR - Pará' },
        { value: "30", label: 'DR - Paraíba' },
        { value: "32", label: 'DR - Pernambuco' },
        { value: "34", label: 'DR - Piauí' },
        { value: "36", label: 'DR - Paraná' },
        { value: "50", label: 'DR - Rio de Janeiro' },
        { value: "60", label: 'DR - Rio Grande do Norte' },
        { value: "26", label: 'DR - Rondonia' },
        { value: "65", label: 'DR - Roraima' },
        { value: "64", label: 'DR - Rio Grande do Sul' },
        { value: "68", label: 'DR - Santa Catarina' },
        { value: "70", label: 'DR - Sergipe' },
        { value: "74", label: 'DR - São Paulo Interior' },
        { value: "72", label: 'DR - São Paulo' },
        { value: "75", label: 'DR - Tocantins' }
      ],

      valorStates: [
        { value: "AC", label: "Acre" },
        { value: "AL", label: "Alagoas" },
        { value: "AP", label: "Amapá" },
        { value: "AM", label: "Amazonas" },
        { value: "BA", label: "Bahia" },
        { value: "CE", label: "Ceará" },
        { value: "DF", label: "Distrito Federal" },
        { value: "ES", label: "Espírito Santo" },
        { value: "GO", label: "Goiás" },
        { value: "MA", label: "Maranhão" },
        { value: "MT", label: "Mato Grosso" },
        { value: "MS", label: "Mato Grosso do Sul" },
        { value: "MG", label: "Minas Gerais" },
        { value: "PA", label: "Pará" },
        { value: "PB", label: "Paraíba" },
        { value: "PR", label: "Paraná" },
        { value: "PE", label: "Pernambuco" },
        { value: "PI", label: "Piauí" },
        { value: "RJ", label: "Rio de Janeiro" },
        { value: "RN", label: "Rio Grande do Norte" },
        { value: "RS", label: "Rio Grande do Sul" },
        { value: "RO", label: "Rondônia" },
        { value: "RR", label: "Roraima" },
        { value: "SC", label: "Santa Catarina" },
        { value: "SP", label: "São Paulo" },
        { value: "SE", label: "Sergipe" },
        { value: "TO", label: "Tocantins" },
      ],

      data_local: this.data,

      stateOptions: [],
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any()
    }
  },
  methods: {
    save_changes() {

      return new Promise(() => {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.$vs.loading();
            delete this.data_local.remetente.valid;
            this.data_local.remetente.last_name = " "
            this.$store.dispatch("sigep/updateCreds", this.data_local)
              .then(res => {

                if (!res.valid_error) {
                  this.$vs.notify({
                    title: 'Tudo ok!',
                    text: 'Credenciais autenticadas',
                    color: 'success',
                    iconPack: 'feather',
                    icon: 'icon-check'
                  })
                } else {

                  const text = `${res.valid_error}<br /><br />Por favor, revise suas <strong>CREDENCIAIS</strong><br /><br />Lembre-se que precisam ser os dados do usuário MASTER do SIGEPWEB, caso contrário não vai funcionar`;

                  this.$vs.notify({
                    time: 20000,
                    title: 'ERRO na autenticação do SIGEPWEB',
                    text,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-check'
                  })
                }

                this.$vs.loading.close();

              })
              .catch(() => {
                // console.error(err) 

                this.$vs.notify({
                  title: 'Erro',
                  text: 'Ocorreu um erro, tente novamente!',
                  color: 'warning',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle'
                })

                this.$vs.loading.close();

              })
            // if form have no errors

          }
        })
      })

    },

  },
}

</script>

<style scoped lang="css">
  .important-section {
    border: 1px solid red;
    padding: 0px 15px 15px 15px;
  }
  .important-section > .flex.items-end {
    margin-top: -10px;
    background-color: white;
  }
</style>